import React, { Component } from 'react';
import './QuestionItem.css';


class Info extends Component {
    render() {

        return (
            <div className='questionItem'>
                <div className='content'>
                    Begin English Test—45 minutes, 75 questions
                    In the five passages that follow, certain words and phrases are underlined and highlighted. On the right-hand side of the screen, you will find alternatives for the underlined and highlighted part. In most cases, you are to choose the one that best expresses the idea, makes the statement appropriate for standard written English, or is worded most consistently with the style and tone of the passage as a whole. If you think the original version is best, choose “NO CHANGE.” In some cases, you will find on the right-hand side of the screen a question about the underlined and highlighted part. You are to choose the best answer to the question.
                    You will also find questions about a section of the passage, or about the passage as a whole. These questions do not refer to an underlined portion of the passage, but rather refer to a letter or letters, a number or numbers, or an asterisk within square brackets [ ].
                    For each question, choose the alternative you consider best, select the circle next to your answer, then select the Next button. Read each passage through once, using the scroll bar to see the entire passage, before you begin to answer the questions that accompany the passage. For many of the questions, you must read several sentences beyond the question to determine the answer. Be sure that you have read far enough ahead each time you choose an alternative.
                    Select the Next button to proceed.
                </div>
            </div>
        );
    }
}

export default Info;
